export default __webpack_public_path__ + "static/media/4.e6cc357e.jpg";